import { Button, Result } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  onRetry?: () => void
}

export function PageError({ onRetry }: Props) {
  const { t } = useTranslation()

  return (
    <Result
      status="error"
      title={t('common.errors.detailLoadFailed')}
      extra={
        onRetry && (
          <Button type="primary" onClick={onRetry}>
            {t('common.buttons.retry')}
          </Button>
        )
      }
    />
  )
}
